export type { SdQuizStickyCtaProps } from './sd-quiz-sticky-cta'
export { SdQuizStickyCta } from './sd-quiz-sticky-cta'
